/**
 * useWelcomeContent
 *
 * Loads editable landing content from portal-backend once on mount. Returns
 * `null` while loading or when the API is unavailable, so welcome components
 * can fall back to the bundled i18n copy (API -> fallback pattern, like
 * PersonalDetailsStep's FALLBACK_CITIES).
 */

import { useEffect, useState } from 'react';
import { fetchWelcomeContent } from 'features/courier-onboarding/services/welcomeContentService';
import type { WelcomeContent } from './welcomeContent';

export const useWelcomeContent = (): {
  content: WelcomeContent | null;
  loading: boolean;
} => {
  const [content, setContent] = useState<WelcomeContent | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;

    fetchWelcomeContent()
      .then((data) => {
        if (!cancelled) setContent(data);
      })
      .catch(() => {
        // Silent: components fall back to i18n copy.
        if (!cancelled) setContent(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { content, loading };
};

export default useWelcomeContent;
